
export type CheckEnrollmentEligibilityParams = {
/**
 * 학생 ID
 */
studentId: string;
};
